import { defineStore } from "pinia";

export const useGlobalStore = defineStore("global", {
    state: () => {
        return {
        };
    },

    getters: {
    },

    actions: {
        addCommasToFloat(number) {
            if (number) {
                let parts = number.toString().split('.');
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join('.');
            } else {
                return 0
            }
        },
        checkPrice(number) {
            try {
                var numberString = Number(number).toString();
                if (numberString.indexOf(".") > 0) {
                    var len = 3;
                    try {
                        len = numberString.split(".")[1].length;
                    } catch {
                        len = 3;
                    }
                    if (len > 3) {
                        try {
                            len = numberString.split(".")[1].split("000").length;
                        } catch {
                            len = 0;
                        }
                        if (len > 0) {
                            return this.addCommasToFloat(number.toFixed(4))
                        } else {
                            return this.addCommasToFloat(number.toFixed(3))
                        }
                    } else {
                        return this.addCommasToFloat(number.toFixed(3))
                    }
                } else {
                    return this.addCommasToFloat(number);
                }
            } catch {
                return this.addCommasToFloat(number)
            }
        },
        converter(number) {
            let stringNumber = String(number).substring(0, String(number).indexOf("."));
            let len = stringNumber.length;
            if (len >= 4 && len < 7) {
                //T
                return String((Number(stringNumber) / 10 ** 3).toFixed(2)) + "K";
            } else if (len >= 7 && len < 10) {
                //M
                return String((Number(stringNumber) / 10 ** 6).toFixed(2)) + "M";
            } else if (len >= 10) {
                //B
                return String((Number(stringNumber) / 10 ** 9).toFixed(2)) + "B";
            } else {
                return this.addCommasToFloat(Number(number));
            }
        }
    },
});